<button
  class="toggle"
  type="button"
  (click)="toggleOpen()"
  type="button"
  [style.color]="color"
>
  <riv-icon
    *ngIf="chevronPosition === 'left'"
    [class.open]="open"
    [name]="'ChevronDown'"
    [size]="iconSize"
  ></riv-icon>
  <div
    [ngClass]="{
      'mr-xsmall': toggleSize === 'small' && chevronPosition === 'right',
      'ml-xsmall': toggleSize === 'small' && chevronPosition === 'left',
      'small-variant-text': toggleSize === 'small'
    }"
  >
    {{ open ? hideLabel : showLabel }}
  </div>
  <riv-icon
    *ngIf="chevronPosition === 'right'"
    [class.open]="open"
    [name]="'ChevronDown'"
    [size]="iconSize"
  ></riv-icon>
</button>
<div *ngIf="open">
  <ng-content></ng-content>
</div>
